import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

/**
 * Public kiosek route — bez auth. Autorizace je přes signed JWT token
 * v search paramu. Layout je full-screen bez AppShell (mimo dashboard).
 *
 * `errorComponent` zachytí chybu z `validateSearch` (např. chybějící token),
 * aby se uživateli místo surového Zod JSON ukázala srozumitelná hláška.
 */
function KioskInvalidLink() {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-3 bg-background p-8 text-center"
      data-testid="kiosk-invalid-link"
    >
      <h1 className="text-2xl font-bold text-foreground">Neplatný odkaz na kiosek</h1>
      <p className="max-w-md text-muted-foreground">
        Tento odkaz je neplatný nebo jeho platnost vypršela. Vygenerujte prosím nový v aplikaci na
        detailu termínu tlačítkem „Kiosek".
      </p>
    </div>
  );
}

export const Route = createFileRoute("/kiosk/$terminId")({
  validateSearch: z.object({
    token: z.string().min(10, "Token je povinný"),
  }),
  errorComponent: KioskInvalidLink,
});
